import React from "react";

import SelectBox from "../../../../components/select-box/select-box";
import { Button } from "../../../../components/buttons";
import { InputMonthYear } from "../../../../components/form";
import { FilterContainer } from "./filter-style";

import { getRelatedMediatorsCodes } from "../../../../utils/mediatorCode";
import { isMonthYearGreaterThan, isMonthYearGreaterThanYear } from "../../../../utils/time";
import { FilterProps, FilterType, MediatorCodesInputType } from "../clients-dashboard-types";
import { ERROR_MESSAGES } from "../../../../constants/errorMessages";
import { TABPARAMNAME } from "../../../../constants/clientsDashboard";
import { useClientsDashboardContext } from "../context/clients-dashboard-context";

const Filter = ({ mediator, filter, tab, setFilter, onGenerate }: FilterProps) => {
  const { mediatorCode, setMediatorCode } = useClientsDashboardContext();

  const updateFilter = (newFilter: Partial<FilterType>) => {
    setFilter((prevFilter) => ({ ...prevFilter, ...newFilter }));
  };

  const handleChangeFilter = (value: string, input: keyof FilterType) => {
    updateFilter({
      [input]: value,
      ...(input === "from" ? { errorFrom: "" } : {}),
      ...(input === "to" ? { errorTo: "" } : {}),
    });
    if (input === "from" && value.length === 7 && filter.to.length === 7) {
      validateDate(input, value, filter.to);
      return;
    }
    if (input === "to" && value.length === 7 && filter.from.length === 7) {
      validateDate(input, filter.from, value);
      return;
    }
    if (input === "mediatorCode") {
      setMediatorCode(value);
    }
  };

  const validateDate = (field: string, from: string, to: string) => {
    const isMoreThanOneYear = isMonthYearGreaterThanYear(from, to);
    const isFromGreater = isMonthYearGreaterThan(from, to);

    if (isFromGreater || isMoreThanOneYear) {
      if (field === "from") {
        updateFilter({
          errorFrom: isMoreThanOneYear
            ? ERROR_MESSAGES["invalid-month-year-date-diff"]
            : ERROR_MESSAGES["invalid-first-month-year-date"],
          errorTo: "",
        });
      }
      if (field === "to") {
        updateFilter({
          errorTo: isMoreThanOneYear
            ? ERROR_MESSAGES["invalid-month-year-date-diff"]
            : ERROR_MESSAGES["invalid-second-month-year-date"],
          errorFrom: "",
        });
      }
    } else {
      updateFilter({ errorFrom: "", errorTo: "" });
    }
  };

  const validateFilter = () => {
    if (filter.errorFrom || filter.errorTo) return true;
    if (
      !filter.from ||
      filter.from.length !== 7 ||
      !filter.to ||
      filter.to.length !== 7 ||
      !filter.mediatorCode
    ) {
      return true;
    }
    return false;
  };

  const disabled = validateFilter();
  const disabledDates = tab === TABPARAMNAME.RENOVACIONES || tab === TABPARAMNAME.IMPAGADOS;

  const mediatorCodesInput: MediatorCodesInputType = {
    codeOptions: getRelatedMediatorsCodes(mediator),
    selectedCode: filter.mediatorCode,
  };

  return (
    <FilterContainer className={`${disabledDates ? "no-dates" : ""}`}>
      {!disabledDates && (
        <>
          <InputMonthYear
            value={filter.from}
            onChange={(value: string) => handleChangeFilter(value, "from")}
            id="input-month-year-from"
            label="Desde"
            error={filter.errorFrom}
            required
            disabled={disabledDates}
            noData={disabledDates}
          />

          <InputMonthYear
            value={filter.to}
            onChange={(value: string) => handleChangeFilter(value, "to")}
            id="input-month-year-to"
            label="Hasta"
            error={filter.errorTo}
            required
            disabled={disabledDates}
            noData={disabledDates}
          />
        </>
      )}

      <div className="selectBox relatedMediators">
        <SelectBox
          isMediator
          optionsText={mediatorCodesInput.codeOptions}
          optionKey="value"
          optionValue="label"
          defaultValue={mediatorCode}
          initialValue={mediatorCodesInput.selectedCode}
          propValue={mediatorCodesInput.selectedCode}
          disabled={mediatorCodesInput.codeOptions.length < 2}
          required
          onChange={(value: string) => handleChangeFilter(value, "mediatorCode")}
        />
        <label>Mediador</label>
      </div>

      <div className="button-container">
        <Button text="Generar" disabled={disabled} onClick={onGenerate} />
      </div>
    </FilterContainer>
  );
};

export default Filter;
